export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-comments-2d8669f1a3d502b78acf1c7b557c4e56.svg";